import { useTranslation } from 'react-i18next'

import { ComboBox, CountryFlag } from '@reveni-io/reveni-ui'

import { languages } from '@/common/constants'

import * as Styles from './styles'

const LanguageSelector = ({ supportedLanguages, selectedLanguage, onChange }) => {
  const { t } = useTranslation()

  const getOptions = () => {
    const availableLanguages = languages(t).filter(lang => supportedLanguages?.includes(lang.value))

    return availableLanguages?.map(language => ({
      value: language.value,
      label: (
        <Styles.OptionsContainer>
          <CountryFlag code={language.value === 'en' ? 'GB' : language.value} /> {language.label}
        </Styles.OptionsContainer>
      ),
    }))
  }

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <ComboBox
      label={t('Idioma notificaciones')}
      value={selectedLanguage}
      menuItems={getOptions()}
      handleChange={handleChange}
      fullWidth
    />
  )
}
export default LanguageSelector
